import { Fade as _Fade, FadeProps as _FadeProps } from "reactstrap";

    export const Fade = _Fade;
    export type FadeProps = _FadeProps;
    